import React from 'react';

export interface WindowContextValue {
  locationAssign: (url: string) => void;
}

export default React.createContext<WindowContextValue>({
  locationAssign: (url: string) => {
    window.location.href = url;
  },
});
